import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const StepShapeIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="207"
      height="136"
      viewBox="0 0 207 136"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1294_6025)">
        <rect
          y="-6.10352e-05"
          width="206.204"
          height="135.506"
          rx="17.6746"
          fill={props.fill || "currentColor" || "#D3E7FF"}
        />
        <circle cx="203.548" cy="2.65674" r="13.256" fill="white" />
        <circle cx="162.017" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="162.017" cy="135.506" r="2.94577" fill="white" />
        <circle cx="150.234" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="150.234" cy="135.506" r="2.94577" fill="white" />
        <circle cx="138.451" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="138.451" cy="135.506" r="2.94577" fill="white" />
        <circle cx="126.668" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="126.668" cy="135.506" r="2.94577" fill="white" />
        <circle cx="114.885" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="114.885" cy="135.506" r="2.94577" fill="white" />
        <circle cx="103.102" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="103.102" cy="135.506" r="2.94577" fill="white" />
        <circle cx="91.3188" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="91.3188" cy="135.506" r="2.94577" fill="white" />
        <circle cx="79.5358" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="79.5358" cy="135.506" r="2.94577" fill="white" />
        <circle cx="67.7528" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="67.7528" cy="135.506" r="2.94577" fill="white" />
        <circle cx="55.9697" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="55.9697" cy="135.506" r="2.94577" fill="white" />
        <circle cx="44.1867" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="44.1867" cy="135.506" r="2.94577" fill="white" />
        <circle cx="32.4034" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="32.4034" cy="135.506" r="2.94577" fill="white" />
        <circle cx="20.6204" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="20.6204" cy="135.506" r="2.94577" fill="white" />
        <circle cx="173.801" cy="-0.000333309" r="2.94577" fill="white" />
        <circle cx="173.801" cy="135.506" r="2.94577" fill="white" />
        <circle cx="206.204" cy="26.5116" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="26.5116" r="2.94577" fill="white" />
        <circle cx="206.204" cy="38.2943" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="38.2943" r="2.94577" fill="white" />
        <circle cx="206.204" cy="50.0783" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="50.0783" r="2.94577" fill="white" />
        <circle cx="206.204" cy="61.8609" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="61.8609" r="2.94577" fill="white" />
        <circle cx="206.204" cy="73.6443" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="73.6443" r="2.94577" fill="white" />
        <circle cx="206.204" cy="85.4269" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="85.4269" r="2.94577" fill="white" />
        <circle cx="206.204" cy="97.2108" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="97.2108" r="2.94577" fill="white" />
        <circle cx="206.204" cy="108.994" r="2.94577" fill="white" />
        <circle cx="0.000216007" cy="108.994" r="2.94577" fill="white" />
        <circle cx="203.548" cy="133.151" r="13.256" fill="white" />
        <circle cx="2.05188" cy="2.65674" r="13.256" fill="white" />
        <circle cx="2.05188" cy="133.151" r="13.256" fill="white" />
        <rect
          x="11.9114"
          y="9.90946"
          width="182.381"
          height="115.315"
          rx="17.2746"
          stroke="#125289"
          strokeWidth="0.8"
          strokeDasharray="2.54 2.54"
        />
      </g>
      <defs>
        <clipPath id="clip0_1294_6025">
          <rect width="206.204" height="135.506" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StepShapeIcon;
